
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useSavedResumes } from "./useSavedResumes";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";

export const useOriginalResumes = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const result = useSavedResumes({ onlyOriginals: true });
  
  // Fetch directly from the database to ensure fresh data
  const fetchOriginalResumes = async () => {
    if (!user) return [];
    
    const { data, error } = await supabase
      .from("resumes")
      .select("*")
      .eq("user_id", user.id)
      .eq("is_original", true)
      .order("created_at", { ascending: false });
      
    if (error) throw error;
    return data || [];
  };
  
  return {
    ...result,
    refetch: async () => {
      // Force refetch original data
      const freshData = await fetchOriginalResumes();
      
      // Update the cache with fresh data
      queryClient.setQueryData(["resumes", user?.id, false, true], freshData);
      
      // Invalidate all resume-related queries to ensure UI consistency
      queryClient.invalidateQueries({ queryKey: ["resumes"] });
      
      // Call the original refetch too
      return result.refetch();
    }
  };
};
